import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../js/void.mjs';
import {
  equals2au1ep9vhcato as equals,
  getStringHashCode26igk1bx568vk as getStringHashCode,
} from '../../../js/coreRuntime.mjs';
import { KClass1cc9rfeybg8hs as KClass } from '../../KClassJs.mjs';
import { UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException } from '../../../exceptions.mjs';
import { jsIsType3jt51kzl8sm7y as jsIsType } from '../../../js/typeCheckUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var PrimitiveKClassImplClass;
function PrimitiveKClassImpl() {
  if (PrimitiveKClassImplClass === VOID) {
    class $ extends KClassImpl() {
      constructor(jClass, givenSimpleName, isInstanceFunction) {
        super();
        this.df_1 = jClass;
        this.ef_1 = givenSimpleName;
        this.ff_1 = isInstanceFunction;
      }
      bf() {
        return this.df_1;
      }
      equals(other) {
        if (!(other instanceof PrimitiveKClassImpl()))
          return false;
        return super.equals(other) && this.ef_1 === other.ef_1;
      }
      j1() {
        return this.ef_1;
      }
      cf(value) {
        return this.ff_1(value);
      }
    }
    initMetadataForClass($, 'PrimitiveKClassImpl');
    PrimitiveKClassImplClass = $;
  }
  return PrimitiveKClassImplClass;
}
var KClassImplClass;
function KClassImpl() {
  if (KClassImplClass === VOID) {
    class $ {
      i1() {
        return null;
      }
      equals(other) {
        var tmp;
        if (other instanceof NothingKClassImpl()) {
          tmp = false;
        } else {
          if (other instanceof KClassImpl()) {
            tmp = equals(this.bf(), other.bf());
          } else {
            tmp = false;
          }
        }
        return tmp;
      }
      hashCode() {
        var tmp0_safe_receiver = this.j1();
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : getStringHashCode(tmp0_safe_receiver);
        return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
      }
      toString() {
        return 'class ' + this.j1();
      }
    }
    initMetadataForClass($, 'KClassImpl', VOID, VOID, [KClass()]);
    KClassImplClass = $;
  }
  return KClassImplClass;
}
var NothingKClassImplClass;
function NothingKClassImpl() {
  if (NothingKClassImplClass === VOID) {
    class $ extends KClassImpl() {
      constructor() {
        NothingKClassImpl_instance = null;
        super();
        NothingKClassImpl_instance = this;
        this.gf_1 = 'Nothing';
      }
      j1() {
        return this.gf_1;
      }
      cf(value) {
        return false;
      }
      bf() {
        throw UnsupportedOperationException().a1("There's no native JS class for Nothing type");
      }
      equals(other) {
        return other === this;
      }
      hashCode() {
        return 0;
      }
    }
    initMetadataForObject($, 'NothingKClassImpl');
    NothingKClassImplClass = $;
  }
  return NothingKClassImplClass;
}
var NothingKClassImpl_instance;
function NothingKClassImpl_getInstance() {
  if (NothingKClassImpl_instance === VOID)
    new (NothingKClassImpl())();
  return NothingKClassImpl_instance;
}
var SimpleKClassImplClass;
function SimpleKClassImpl() {
  if (SimpleKClassImplClass === VOID) {
    class $ extends KClassImpl() {
      constructor(jClass) {
        super();
        this.hf_1 = jClass;
        var tmp = this;
        // Inline function 'kotlin.js.asDynamic' call
        var tmp0_safe_receiver = this.hf_1.$metadata$;
        // Inline function 'kotlin.js.unsafeCast' call
        tmp.if_1 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.simpleName;
      }
      bf() {
        return this.hf_1;
      }
      j1() {
        return this.if_1;
      }
      cf(value) {
        return jsIsType(value, this.hf_1);
      }
    }
    initMetadataForClass($, 'SimpleKClassImpl');
    SimpleKClassImplClass = $;
  }
  return SimpleKClassImplClass;
}
//region block: exports
export {
  NothingKClassImpl_getInstance as NothingKClassImpl_getInstancewy0n2btt0p4s,
  KClassImpl as KClassImpl3o7kfo8v13fhm,
  PrimitiveKClassImpl as PrimitiveKClassImpl1fv46nzfav2pd,
  SimpleKClassImpl as SimpleKClassImpl1arbnmvef0y44,
};
//endregion

//# sourceMappingURL=KClassImpl.mjs.map
